<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ded">This book is dedicated to all who believe that nothing is impossible</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0003_ded.vue?645819a5